// extracted by mini-css-extract-plugin
export var address = "styles-module--address--007d5";
export var button = "styles-module--button--c3301";
export var content = "styles-module--content--54076";
export var location = "styles-module--location--f782e";
export var text = "styles-module--text--6599d";